var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row recommend-container"},[_c('div',{staticClass:"recommend-list"},[_c('recommend-news-list')],1),_c('div',{staticClass:"week-fast-news"},[_c('WeekFastNewsList')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }